import { keyframes } from '@mui/material';

export const AUDIO_RATE_VALUES: number[] = [0.8, 1, 1.2, 1.5, 1.7, 2, 2.5];

export const HIGHLIGHT_ANIMATION_KEYFRAMES = keyframes`
0% {
  opacity: 0.5;
}
100% {
  opacity: 1;
}
`;
